import { bannerData, bannerPayload, bannerReduxState } from "../../features/createBanner/bannerTypes";
import { Action } from "../../types";

export type eventType = "database"| "moengage"|"firebase";

export type defaultParamsType={
    [key in eventType]: {
        [key : string]:{
            name:string,
            status:string
        }
    }
}

export type defaultEventType={
    [key:string]:{
        id:string,
        status:string,
        mappings:{
            [key in eventType]:{
                name:string,
                params:{
                    [key:string]:string
                }
            }
        }
    }
}

export type reduxEventState = {
    defaultParams:defaultParamsType,
    events:defaultEventType
}

const initialState:reduxEventState | null = null;
export function eventReducer(state: reduxEventState | null = initialState, action: Action<reduxEventState>): reduxEventState | null{
    switch(action.type){
        case "setEventState": {
            if(action.payload){
                return action.payload
            }else{
                return state;
            }
        }
        default: {
            return state;
        }
    }
}